import { ExportOptions, QualityPropertyFilters } from "./qualifyForHabi.types";

export const getQualifyPropertiesForHabi = async (
  token: string,
  params: QualityPropertyFilters
) => {
  const data_params = new URLSearchParams();
  data_params.append("country", "MX");

  const filtersToRemoveIfEmpty = ["city_id", "broker_type", "feed_name"];
  const filtersToRemoveIfValue3 = [
    "property_exported",
    "user_exported",
    "is_interested",
    "from_xml",
    "whatsapp_sent",
    "pipe_drive_deals"
  ];
  for (const filter in params) {
    const value = params[filter];
    if (value !== undefined && value !== null && value !== "") {
      data_params.append(filter, value);
      if (filtersToRemoveIfEmpty.includes(filter) && value.length === 0) {
        data_params.delete(filter);
      }
      if (filtersToRemoveIfValue3.includes(filter) && value === 3) {
        data_params.delete(filter);
      }
    }
  }
  const result = await fetch(
    `${process.env.REACT_APP_ADMINISTRATION_NEW_API_URL
    }/qualify_property_for_habi?${data_params.toString()}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": process.env.REACT_APP_MICRO_GLOBAL_ENTITY_XAPIKEY,
      },
    }
  );
  return result.json();
};

export const getMunicipalitiesApi = async (token: string, stateId: number) => {
  const result = await fetch(
    `${process.env.REACT_APP_URL_PROPIEDADES}/api/v3/location/municipalities?stateId=${stateId}`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return result.json();
};

export const postSaveHistoryApi = async (
  token: string,
  filters,
  rowSelected: string[],
  exportOptions: ExportOptions
) => {
  const result = await fetch(
    `${process.env.REACT_APP_ADMINISTRATION_NEW_API_URL}/qualify_property_for_habi/history?country=MX`,
    {
      method: "POST",
      body: JSON.stringify({
        properties: rowSelected,
        filters: { ...filters },
        ...exportOptions
      }),
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": process.env.REACT_APP_MICRO_GLOBAL_ENTITY_XAPIKEY,
      },
    }
  );
  return result.json();
};

export const postSendWhatsAppApi = async (
  token: string,
  rowSelected: number[]
) => {
  const result = await fetch(
    `${process.env.REACT_APP_LEADS_API}send_offer_whatsapp?country=MX`,
    {
      method: "POST",
      body: JSON.stringify({
        properties: rowSelected,
      }),
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": process.env.REACT_APP_LEADS_APIKEY,
      },
    }
  );
  return result.json();
};

export const getFeedNameListApi = async (
  token: string
) => {
  const result = await fetch(
    `${process.env.REACT_APP_MICRO_GLOBAL_ENTITY}qualify_property_for_habi/get_feed_names?country=MX`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return result.json();
};
